import * as gtag from '@/common/utils/gtags.client';
import { Vehicle } from '@/catalog/types';
import { useEffect, useState } from 'react';
import { getFloatCurrency } from '@/util-conversion/currency/currency-to-number';
import { FSProperty } from '@/fullstory/utils/fullstory-event';

export function usePushVehicleVariablesToDataLayer(
  vehicle?: Vehicle,
  vehicleCartImage?: string,
  ageRange?: string,
  creditRange?: string,
  market?: FSProperty,
  bodyType?: string,
  standardizedBasePrice?: number,
  crossMarket?: string
) {
  const [hasSent, setHasSent] = useState(false);

  const payload = vehicle
    ? Object.fromEntries(
        Object.entries({
          inventory_id: vehicle.id,
          make_model: `${vehicle.make} ${vehicle.model}`,
          market: market,
          standardized_base_price: standardizedBasePrice
            ? getFloatCurrency(standardizedBasePrice)
            : undefined,
          vehicle_color: vehicle.exterior_color_basic,
          vehicle_mileage: Math.round(vehicle.odometer),
          vehicle_trim: vehicle.trim,
          vehicle_year: vehicle.model_year,
          age_range: ageRange?.toUpperCase(),
          credit_range: creditRange?.toUpperCase(),
          abandoned_cart_image: vehicleCartImage,
          body_type: bodyType,
          cross_market: crossMarket,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        }).filter(([_, value]) => value !== undefined)
      )
    : undefined;

  useEffect(() => {
    if (
      !payload?.inventory_id &&
      !payload?.abandoned_cart_image &&
      !payload?.age_range &&
      !payload?.credit_range &&
      !payload?.body_type
    ) {
      return;
    }

    gtag.pushData({
      inventory_id: payload.inventory_id,
      make_model: payload.make_model,
      market: payload.market,
      standardized_base_price: payload.standardized_base_price,
      vehicle_color: payload.vehicle_color,
      vehicle_mileage: payload.vehicle_mileage,
      vehicle_trim: payload.vehicle_trim,
      vehicle_year: payload.vehicle_year,
      age_range: payload.age_range,
      credit_range: payload.credit_range,
      abandoned_cart_image: payload.abandoned_cart_image,
      body_type: payload.body_type,
      cross_market: payload.cross_market,
    });

    setHasSent(true);
  }, [
    payload?.abandoned_cart_image,
    payload?.age_range,
    payload?.credit_range,
    payload?.inventory_id,
    payload?.make_model,
    payload?.market,
    payload?.standardized_base_price,
    payload?.vehicle_color,
    payload?.vehicle_mileage,
    payload?.vehicle_trim,
    payload?.vehicle_year,
    payload?.body_type,
    payload?.cross_market,
  ]);

  return hasSent;
}
